[
    {
        "id":1,      
        "name": "Cedula de ciudadania",
        "acronym": "CC"
    },
    {
        "id":2,
        "name": "Cedula extranjeria",
        "acronym": "CE"
    },
    {
        "id":3,
        "name": "Pasaporte",
        "acronym": "PA"
    },
    {
        "id":4,
        "name": "NIT",
        "acronym": "NI"
    },
    {
        "id":5,
        "name": "Tarjeta de Identidad",
        "acronym": "TI"
    }
]